import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { utils as commonUtils } from '@finley-technologies/common';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import 'borrower/borrower.scss';
import { colors } from 'packages/common-frontend/colors';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { AssignmentEditContainer } from 'packages/loanProduct/ui/AssignmentEditContainer';
import { AssignmentLoadingSkeleton } from 'packages/loanProduct/ui/AssignmentSkeletonLoadingTables';

export const AssignmentEditRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();

  let routeLevelError = false;

  const { data: userData, loading: userLoading } = useGetUserQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
  });

  if (!userData || !userData.user || userLoading) {
    return (
      <AssignmentLoadingSkeleton dataTestId="loading-assignment-edit-route" />
    );
  }
  const {
    user: { organizationId },
  } = userData;

  return (
    <Box width="100%" background={colors.background[50]}>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load assignment edit route`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <AssignmentEditContainer organizationId={organizationId} />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
